export default __webpack_public_path__ + "static/media/ENTJ.6e0440fb.svg";